import AppManagementRequest from './AppManagementRequest';

export default class ServiceAccountTypeRequest extends AppManagementRequest {
	constructor(createdBy, requirementNumber, app, serviceAccountType) {
		super(app, createdBy, requirementNumber);
		this.serviceAccountType = serviceAccountType
			? serviceAccountType
			: null;
	}
}
